import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { AddGray } from '../../../assets';
import { Button, Modal, Theme } from '../../../components';
import { DepartmentTemplate } from '../../../models';
import { departmentTemplatesSelectors } from '../../../redux';

import './AddEditStore.scss';
import './ManageDepartmentTemplates.scss';

interface Props {
  isOpen: boolean;
  closeModal: () => void;
  addDepartmentTemplateCallback: () => void;
  editDepartmentTemplateCallback: (editDepartmentTemplate: DepartmentTemplate) => void;
  deleteDepartmentTemplateCallback: (editDepartmentTemplate: DepartmentTemplate) => void;
}

const ManageDepartmentTemplates: FC<Props> = ({
  isOpen,
  closeModal,
  addDepartmentTemplateCallback,
  editDepartmentTemplateCallback,
  deleteDepartmentTemplateCallback,
}) => {
  const { t } = useTranslation();

  const departmentTemplates = useSelector(departmentTemplatesSelectors.getDepartmentTemplates);

  const renderDepartmentTemplateList = departmentTemplate => {
    return (
      <div key={`department-template-${departmentTemplate.name}`}>
        <p className='department-list-name'>{departmentTemplate.name}</p>
        <span>
          <Button
            theme={Theme.TRANSPARANT}
            icon='Edit'
            onClickCallback={() => editDepartmentTemplateCallback(departmentTemplate)}
          />
          <Button
            theme={Theme.TRANSPARANT}
            icon='Trashcan'
            onClickCallback={() => deleteDepartmentTemplateCallback(departmentTemplate)}
          />
        </span>
      </div>
    );
  };

  return (
    <Modal title={t('lblEditDepartments')} isOpen={isOpen} closeModal={() => closeModal()}>
      <div className='add-edit-container'>
        <p className='description'>{t('lblDepartmentLinks')}</p>
        <div className='edit-department-template-list'>{departmentTemplates?.map(renderDepartmentTemplateList)}</div>

        <div className='buttons-add-department-template' onClick={addDepartmentTemplateCallback}>
          <span>
            {' '}
            <AddGray />{' '}
          </span>
          <p>{t('lblAddDepartment')} </p>
        </div>

        <div className='buttons'>
          <Button theme={Theme.INVERSE} onClickCallback={closeModal}>
            {t('lblCancel')}
          </Button>
          <Button theme={Theme.SECONDARY} onClickCallback={closeModal} isLoading={false}>
            {t('lblSave')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ManageDepartmentTemplates;
